/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_Changeavatar1Inputs */

const id_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubah Avatar`)
};

const ms_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar Avatar`)
};

const da_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skift Avatar`)
};

const de_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar ändern`)
};

const en_us2_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change Avatar`)
};

const es_es2_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar avatar`)
};

const es_mx2_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar avatar`)
};

const fil_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palitan ang Avatar`)
};

const fr_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer l'avatar`)
};

const it_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia avatar`)
};

const hu_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar csere`)
};

const nl_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatar wijzigen`)
};

const no_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endre avatar`)
};

const pl_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień awatar`)
};

const pt_br2_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar Avatar`)
};

const pt_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar avatar`)
};

const ro_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schimbă avatarul`)
};

const fi_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaihda avatar`)
};

const sv_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändra avatar`)
};

const vi_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi ảnh đại diện`)
};

const tr_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avatarı Değiştir`)
};

const cs_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit avatar`)
};

const bg_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промяна на аватар`)
};

const ru_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сменить аватар`)
};

const uk_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Змінити аватар`)
};

const ar_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الصورة الرمزية`)
};

const hi_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवतार बदलें`)
};

const th_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนรูปโปรไฟล์`)
};

const ja_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アバターを変更`)
};

const zh_cn2_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改头像`)
};

const zh_hant1_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`變更大頭貼`)
};

const ko_profile_avatar_changeavatar1 = /** @type {(inputs: Profile_Avatar_Changeavatar1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아바타 변경`)
};

/**
* | output |
* | --- |
* | "Change Avatar" |
*
* @param {Profile_Avatar_Changeavatar1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_avatar_changeavatar1 = /** @type {((inputs?: Profile_Avatar_Changeavatar1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_Changeavatar1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_avatar_changeavatar1(inputs)
	if (locale === "ms") return ms_profile_avatar_changeavatar1(inputs)
	if (locale === "da") return da_profile_avatar_changeavatar1(inputs)
	if (locale === "de") return de_profile_avatar_changeavatar1(inputs)
	if (locale === "en-US") return en_us2_profile_avatar_changeavatar1(inputs)
	if (locale === "es-ES") return es_es2_profile_avatar_changeavatar1(inputs)
	if (locale === "es-MX") return es_mx2_profile_avatar_changeavatar1(inputs)
	if (locale === "fil") return fil_profile_avatar_changeavatar1(inputs)
	if (locale === "fr") return fr_profile_avatar_changeavatar1(inputs)
	if (locale === "it") return it_profile_avatar_changeavatar1(inputs)
	if (locale === "hu") return hu_profile_avatar_changeavatar1(inputs)
	if (locale === "nl") return nl_profile_avatar_changeavatar1(inputs)
	if (locale === "no") return no_profile_avatar_changeavatar1(inputs)
	if (locale === "pl") return pl_profile_avatar_changeavatar1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_avatar_changeavatar1(inputs)
	if (locale === "pt") return pt_profile_avatar_changeavatar1(inputs)
	if (locale === "ro") return ro_profile_avatar_changeavatar1(inputs)
	if (locale === "fi") return fi_profile_avatar_changeavatar1(inputs)
	if (locale === "sv") return sv_profile_avatar_changeavatar1(inputs)
	if (locale === "vi") return vi_profile_avatar_changeavatar1(inputs)
	if (locale === "tr") return tr_profile_avatar_changeavatar1(inputs)
	if (locale === "cs") return cs_profile_avatar_changeavatar1(inputs)
	if (locale === "bg") return bg_profile_avatar_changeavatar1(inputs)
	if (locale === "ru") return ru_profile_avatar_changeavatar1(inputs)
	if (locale === "uk") return uk_profile_avatar_changeavatar1(inputs)
	if (locale === "ar") return ar_profile_avatar_changeavatar1(inputs)
	if (locale === "hi") return hi_profile_avatar_changeavatar1(inputs)
	if (locale === "th") return th_profile_avatar_changeavatar1(inputs)
	if (locale === "ja") return ja_profile_avatar_changeavatar1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_avatar_changeavatar1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_avatar_changeavatar1(inputs)
	return ko_profile_avatar_changeavatar1(inputs)
});
export { profile_avatar_changeavatar1 as "profile.avatar.changeAvatar" }